<template>
  <div>
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group id="loginMailGroup"
                    label=""
                    label-for="loginMail">
        <b-form-input id="loginMail"
                      type="email"
                      v-model.trim="form.email"
                      required
                      placeholder="your@email.com"
                       autocomplete="username">
        </b-form-input>
      </b-form-group>
      <b-form-group id="loginPasswordGroup"
                    label=""
                    label-for="loginPassword">
        <b-form-input id="loginPassword"
                      type="password"
                      v-model="form.password"
                      required
                      placeholder="********"
                      autocomplete="current-password">
        </b-form-input>
      </b-form-group>
      <b-button type="submit" variant="primary" class="mr-2">Sign-in</b-button>
      <b-button :to="{name:'register'}" variant="outline-primary" >Register</b-button>
      <b-button :to="{name:'reminder'}" variant="link" class="mr-2">Password Reset</b-button>




    </b-form>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      show: true
    }
  },
  computed: {},
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      this.$store.dispatch('auth/signIn', this.form)
    }
  }
}
</script>

<!-- b-form-1.vue -->

<style scoped>
</style>
